import { Box, IconButton } from '@chakra-ui/react';
import * as React from 'react';

import { XIcon } from '@/imports/ui/chakra/feather';

export const RichPreview: React.FC<{
  html: string;
  canEdit: boolean;
  onCloseClick: () => void;
}> = (props) => (
  <Box
    sx={{
      height: '0',
      width: '100%',
      paddingBottom: '75%' /* 4:3 */,
      position: 'relative',
      overflow: 'hidden',

      iframe: {
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
      },
    }}
  >
    {props.canEdit && (
      <IconButton
        aria-label="hide preview"
        colorScheme="gray"
        size="xs"
        borderRadius="full"
        position="absolute"
        top={4}
        right={4}
        zIndex="1"
        onClick={props.onCloseClick}
        icon={<XIcon />}
      />
    )}

    <iframe srcDoc={props.html}></iframe>
  </Box>
);
